export default __webpack_public_path__ + "static/Eveentology-38a4da114e4363e5dffc882181fffb20.svg";